var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('Header',{ref:"header",attrs:{"moduleTitle":_vm.moduleTitle}},[_c('template',{slot:"searchBox"},[_c('Search',{ref:"search",on:{"search":_vm.searchList}})],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }